export interface InboxTokenResponse {
  token: string;
}

export interface InboxPostMessage {
  origin: string;
  type: InboxMessageTypes;
  id?: string;
  payload: InboxLeadPayload | InboxMessagePayload | InboxLiveChatRequestPayload;
}

export interface InboxMessagePayload {
  data: {
    messagedBy: string;
    data: string;
    uuid: string;
    _bot: string;
    notificationType: NotificationTypes;
  };
  message: string;
  title: string;
}

export interface InboxLeadPayload {
  data: {
    message: string;
  };
  message: string;
  title: string;
}

export interface InboxLiveChatRequestPayload {
  data: {
    message: string;
  };
  message: string;
  title: string;
}

export enum InboxMessageTypes {
  MESSAGE = 'message',
  LEAD = 'lead',
  LIVE_CHAT_REQUEST = 'live-chat-request',
}

export enum NotificationTypes {
  NEW_MESSAGE = 'NEW_MESSAGE',
}
